<template>
  <div>
    <v-sheet
      class="pa-2"
      :height="this.heightSheet"
      :elevation="this.elevation"
    >
      <line-chart
        v-if="dataCollection != null && chartType === 'Line'"
        :dark="this.dark"
        :height="this.heightChart"
        :chart-data="dataCollection"
        :options="options"
      />
      <bar-chart
        v-else-if="dataCollection != null && chartType === 'Bar'"
        :dark="this.dark"
        :height="this.heightChart"
        :chart-data="dataCollection"
        :options="options"
      />
      <template v-else>
        <LoadingData />
      </template>
    </v-sheet>
  </div>
</template>

<script>
import BarChart from "./core/BarChart.vue";
import LineChart from "./core/LineChart.vue";

import LoadingData from "../LoadingData.vue";

export default {
  name: "AnyChartCore",
  components: { BarChart, LineChart, LoadingData },
  props: {
    elevation: {
      type: Number,
      default: 0,
      require: true,
    },
    chartType: {
      type: String,
      default: "Line",
      require: true,
    },
    heightSheet: {
      type: Number,
      default: 600,
      require: true,
    },
    heightChart: {
      type: Number,
      default: 550,
      require: true,
    },
    dark: {
      type: Boolean,
      default: false,
      require: true,
    },
    dataCollection: {
      type: Object,
      require: true,
    },
    options: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {};
  },
  /*   created() {},
  mounted() {},
  methods: {},
  beforeDestroy() {},
  destroyed() {}, */
};
</script>

<style scoped></style>
